import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SchoolDashboard.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * Resolves /business/dashboard: fetches school and redirects to support or accredited dashboard.
 * If no token or API fails, redirects to /business.
 */
const BusinessDashboardRouter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (!token) {
      navigate('/business', { replace: true });
      return;
    }

    fetch(`${API_BASE_URL}/api/schools/me`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => {
        if (res.status === 401) {
          navigate('/business', { replace: true });
          return null;
        }
        return res.json();
      })
      .then((data) => {
        if (data && data.success && data.school) {
          const path = data.school.schoolType === 'accredited'
            ? '/business/dashboard/accredited'
            : '/business/dashboard/support';
          navigate(path, { replace: true });
        } else {
          navigate('/business', { replace: true });
        }
      })
      .catch(() => navigate('/business', { replace: true }));
  }, [navigate]);

  return (
    <div className="school-dashboard">
      <div className="school-dashboard-loading">
        <span className="material-icons spin">refresh</span>
        <p>Loading your dashboard...</p>
      </div>
    </div>
  );
};

export default BusinessDashboardRouter;
